import TransactionCell from './TransactionCell';

export default TransactionCell;
